// services/agenteService.ts
import { api } from "./api";
import { AgenteResponse } from "../types/agente";

export const AgenteService = {
      // Obtener todos los agentes (activos o inactivos)
  getAll: (activo: boolean) => {
    const url = activo !== undefined ? `/agentes/${activo ? 1 : 0}` : "/agentes";
    return api.get(url);
  },

  getToditos: () => {
    return api.get("agentes/todos");
  },

  // Obtener agente por ID
  getById: (id: number) => {
    if (!Number.isInteger(id) || id <= 0) {
      throw new Error("ID debe ser un número positivo");
    }
    return api.get(`/agentes/${id}/individual`);
  },

  // Obtener agente por IDEmpleado
  getByEmpleado: (id: number) => {
    if (!Number.isInteger(id) || id <= 0) {
      throw new Error("ID debe ser un número positivo");
    }
    return api.get(`/agentes/empleado/${id}`);
  },

  // Crear agente con validación
  crear: (data: AgenteResponse) => {
    return api.post("/agentes", data);
  },

  // Actualizar agente con validación
  actualizar: (id: number, data: AgenteResponse) => {
    return api.put(`/agentes/${id}/actualizar`, data);
  },

  // Desactivar empleado
  desactivar: (id: number) => {
    return api.put(`/agentes/${id}/desactivar`);
  },

  // Activar empleado
  activar: (id: number) => {
    return api.put(`/agentes/${id}/activar`);
  },
}